import { render } from "./plicanteTables.vue?vue&type=template&id=2e9b964d&scoped=true"
import script from "./plicanteTables.vue?vue&type=script&lang=js"
export * from "./plicanteTables.vue?vue&type=script&lang=js"

import "./plicanteTables.vue?vue&type=style&index=0&id=2e9b964d&lang=css&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e9b964d"]])

export default __exports__